var _path, _g, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMundiLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mundiLogo_svg__clip0_516_1115)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mundiLogo_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 0,
    width: 7,
    height: 8,
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.044.12h6.833v7.02h-6.833V.12z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mundiLogo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.877 3.63c0 1.94-1.53 3.51-3.418 3.51a3.361 3.361 0 01-2.49-1.108 3.538 3.538 0 01-.925-2.401c0-1.94 1.53-3.51 3.415-3.51 1.39 0 2.587.85 3.12 2.075.192.439.298.922.298 1.435z",
    fill: "#F05A26"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.228 18.188v8.979h-5.395v-8.979c0-1.89-1.495-3.426-3.34-3.426-1.84 0-3.334 1.536-3.334 3.426v8.979h-5.403v-8.979c0-4.954 3.908-8.978 8.736-8.978 4.828 0 8.736 4.024 8.736 8.978z",
    fill: "#404042"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.064 27.167v-8.979c0-.083.001-.167.004-.25-.125-1.773-1.568-3.176-3.332-3.176-1.84 0-3.333 1.536-3.333 3.426v8.979H0v-8.979C0 13.234 3.908 9.21 8.736 9.21c2.34 0 4.465.946 6.032 2.484 1.568-1.538 3.692-2.484 6.033-2.484 4.827 0 8.736 4.024 8.736 8.978v8.979H24.14v-8.979c0-1.89-1.494-3.426-3.34-3.426-1.787 0-3.248 1.45-3.33 3.265a8.7 8.7 0 01.001.161v8.979h-5.408z",
    fill: "#F05A26"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.421 18.816V9.838h5.395v8.978c0 1.89 1.495 3.426 3.341 3.426 1.84 0 3.334-1.536 3.334-3.426V9.838h5.402v8.978c0 4.955-3.908 8.979-8.736 8.979-4.828 0-8.736-4.024-8.736-8.979zM91.759 27.167h5.403V9.21h-5.403v17.957zM81.586 27.167h-8.484v-5.545h8.484c1.84 0 3.334-1.536 3.334-3.434 0-1.89-1.495-3.426-3.334-3.426h-8.484V9.21h8.484c4.821 0 8.736 4.017 8.736 8.978 0 4.962-3.915 8.979-8.736 8.979z",
    fill: "#404042"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mundiLogo_svg__clip0_516_1115"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h98v28H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMundiLogo);
export default __webpack_public_path__ + "static/media/mundi-logo.b0988d81f7846f899dfde0bec127c50f.svg";
export { ForwardRef as ReactComponent };